import React from 'react';
import { Chart } from 'primereact/chart';
import { OWM_Data } from '../../api/OpenWeatherMap';

type Props = {
  owmData: OWM_Data | null;
};

export const WeatherChart: React.FC<Props> = ({ owmData }) => {
  if (!owmData || !owmData.list || owmData.list.length === 0) {
    return <p>No chart data available.</p>;
  }

  const labels = owmData.list.map(item => {
    const date = new Date(item.dt * 1000); // Convert timestamp to milliseconds
    return date.toLocaleTimeString('pt-BR', { hour: 'numeric', minute: 'numeric' });
  });

  const temperatures = owmData.list.map(item => item.main.temp);

  const data = {
    labels,
    datasets: [
      {
        label: 'Temperatura (°C)',
        data: temperatures,
        borderColor: 'rgb(75, 192, 192)',
        backgroundColor: 'rgba(75, 192, 192, 0.5)',
        tension: 0.1,
        fill: false,
      },
    ],
  };

  const options = {
    maintainAspectRatio: false,
    aspectRatio: 0.6,
    plugins: {
      legend: {
        labels: {
          color: '#495057'
        }
      }
    },
    scales: {
      x: {
        ticks: {
          color: '#495057'
        },
        grid: {
          color: '#ebedef'
        }
      },
      y: {
        ticks: {
          color: '#495057'
        },
        grid: {
          color: '#ebedef'
        }
      }
    }
  };

  return <Chart type="line" data={data} options={options} style={{ height: '100px' }} />;
};